import { render, staticRenderFns } from "./TableMetrics.vue?vue&type=template&id=67f84683&scoped=true"
import script from "./TableMetrics.vue?vue&type=script&lang=js"
export * from "./TableMetrics.vue?vue&type=script&lang=js"
import style0 from "./TableMetrics.vue?vue&type=style&index=0&id=67f84683&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f84683",
  null
  
)

export default component.exports